export const HistoryIcon = ({ size = 20, color = "#212529", ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" {...props}>
      <g clip-path="url(#clip0_17455_108691)">
        <path d="M7.58203 1.75C4.68286 1.75 2.33203 4.10083 2.33203 7H0.582031L2.8512 9.26917L2.89203 9.35083L5.2487 7H3.4987C3.4987 4.7425 5.32453 2.91667 7.58203 2.91667C9.83953 2.91667 11.6654 4.7425 11.6654 7C11.6654 9.2575 9.83953 11.0833 7.58203 11.0833C6.4562 11.0833 5.43536 10.6225 4.70036 9.88167L3.87203 10.71C4.82286 11.6608 6.12953 12.25 7.58203 12.25C10.4812 12.25 12.832 9.89917 12.832 7C12.832 4.10083 10.4812 1.75 7.58203 1.75ZM6.9987 4.66667V7.58333L9.49537 9.065L9.91536 8.35917L7.8737 7.14583V4.66667H6.9987Z" fill="#4E4E4E" />
      </g>
      <defs>
        <clipPath id="clip0_17455_108691">
          <rect width={size} height={size} fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
}; 